import React, { useEffect, useState } from "react";
import { showToast, uploadImage } from "../../Pages/Utils/utils";
import { getCategoryDropdown } from "../../Pages/Utils/utils";

const ResourceForm = ({
    initialData = {},
    onSubmit,
    loading,
    buttonName = 'Create'
}) => {

    const [title, setTitle] = useState("");
    const [subTitle, setSubTitle] = useState("");
    const [proTip, setProTip] = useState("");
    const [category, setCategory] = useState("");
    const [description, setDescription] = useState("");
    const [affiliateInfo, setAffiliateInfo] = useState([
        { name: "", affiliate_img: "", description: "" }
    ]);
    const [imageUrl, setImageUrl] = useState(null);
    const [videos, setVideos] = useState([{ url: "", poster: "" }]);
    const [uploading, setUploading] = useState(false);
    const [categoriesList, setCategoriesList] = useState(false)


    useEffect(() => {
        if (!initialData || Object.keys(initialData).length === 0) return;

        setTitle(initialData.title || "");
        setSubTitle(initialData.sub_title || "");
        setProTip(initialData.pro_tip || "");
        setCategory(initialData.category_id || "");
        setDescription(initialData.description || "");
        setImageUrl(initialData.icon_url || null);

    }, [initialData]);

    useEffect(() => {
        fetchCategories()
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await getCategoryDropdown();

            if (response?.status == 200) {
                setCategoriesList(response?.data);
            } else {
                console.log("cannot fetch categories", response)
            }

        } catch (error) {
            console.error(error);
        }
    };

    const isFormValid =
        title.trim() &&
        subTitle.trim() &&
        description.trim();

    const addAffiliate = () => {
        setAffiliateInfo([
            ...affiliateInfo,
            { name: "", affiliate_img: "", description: "" }
        ]);
    };

    const removeAffiliate = (index) => {
        const updated = [...affiliateInfo];
        updated.splice(index, 1);
        setAffiliateInfo(updated);
    };

    const updateAffiliate = (index, field, value) => {
        const updated = [...affiliateInfo];
        updated[index][field] = value;
        setAffiliateInfo(updated);
    };

    const uploadFile = async (file) => {
        try {
            setUploading(true);

            const formData = new FormData();
            formData.append("file", file);

            const res = await uploadImage(formData);
            if (!res?.data) throw new Error();

            return res.data;

        } catch {
            showToast("Upload failed");
            return null;

        } finally {
            setUploading(false);
        }
    };

    const onIconUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setImageUrl(file)

        // const url = await uploadFile(file);

        // if (url) {
        //     setImageUrl(url);
        //     showToast("Icon uploaded", "success");
        // }
    };

    const removeIcon = () => {
        setImageUrl(null);
    };

    const onAffiliateImageUpload = async (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const url = await uploadFile(file);

        if (url) {
            updateAffiliate(index, "affiliate_img", url);
            showToast("Affiliate image uploaded", "success");
        }
    };

    const onVideoUpload = async (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const url = await uploadFile(file);

        if (url) {
            updateVideo(index, "url", url);
            showToast("Video uploaded", "success");
        }
    };

    const onPosterUpload = async (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const url = await uploadFile(file);

        if (url) {
            updateVideo(index, "poster", url);
            showToast("Poster uploaded", "success");
        }
    };

    const addVideo = () => {
        setVideos([...videos, { url: "", poster: "" }]);
    };

    const removeVideo = (index) => {
        const updated = [...videos];
        updated.splice(index, 1);
        setVideos(updated);
    };

    const updateVideo = (index, field, value) => {
        const updated = [...videos];
        updated[index][field] = value;
        setVideos(updated);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        onSubmit({
            title,
            sub_title: subTitle,
            pro_tip: proTip,
            category_id: category,
            description,
            // affiliateInfo,
            file: imageUrl,
            // video_url: videos
        });
    };

    return (
        <form className="card mb-4" onSubmit={handleSubmit}>
            <div className="card-body">

                <div className="form-group">
                    <label>Title</label>
                    <input
                        className="form-control"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Sub Title</label>
                    <input
                        className="form-control"
                        value={subTitle}
                        onChange={(e) => setSubTitle(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Pro Tip</label>
                    <input
                        className="form-control"
                        value={proTip}
                        onChange={(e) => setProTip(e.target.value)}
                    />
                </div>
                <div className="form-group d-flex flex-column gap-1 mt-2">
                    <label>Select Category</label>
                    <select
                        className="custom-select-dropdown font-bold"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                    >
                        <option value="" className='option'>None</option>
                        {Array.isArray(categoriesList) &&
                            categoriesList.map((list) => (
                                <option key={list.id} value={list.id}>
                                    {list.name}
                                </option>
                            ))}
                    </select>
                </div>

                <div className="form-group mt-3">
                    <label>Description</label>
                    <textarea
                        className="form-control"
                        rows={4}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>
                <div className="form-group mt-3">
                    <label>Icon</label>
                    <div className="d-flex gap-4">
                        {/* <input
                            className="form-control"
                            value={imageUrl}
                            onChange={(e) => setImageUrl(e.target.value)}
                        /> */}
                        <label className="btn btn-outline-primary mb-0" style={{ height: "36px" }}>
                            {uploading ? "Uploading..." : "Select file"}
                            <input hidden type="file" accept="image/*" onChange={onIconUpload} />
                        </label>
                        {imageUrl && (
                            <>
                                <div className="mt-2">
                                    {imageUrl instanceof File ? (
                                        <span>{imageUrl.name}</span>
                                    ) : imageUrl ? (
                                        <img
                                            src={imageUrl}
                                            alt="icon"
                                            style={{ width: 80, height: 80, objectFit: "cover" }}
                                        />
                                    ) : null}

                                </div>
                            </>
                        )}
                    </div>
                </div>

                <button type="submit" className="btn cta-btn mt-4" disabled={loading || !isFormValid}>
                    {buttonName}
                </button>
            </div>
        </form>
    );
};

export default ResourceForm;